import ContainerCustom from "../../../Components/ContainerCustom";
import Table from "../../../Components/Table/Table";
import TableButton from "../../../Components/Buttons/TableButton";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config/api";

export default function AdminsList() {
  // const [activeFilter, setActiveFilter] = useState([true, true, true]);
  const [adminData, setAdminData] = useState(null);
  const fetchAdminsData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/admins/list/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/admins/list/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAdminData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    fetchAdminsData();
  }, []);
  return (
    <>
      <ContainerCustom
        header="لیست مدیران سامانه"
        headSVG="archive"
        // colorfulFilterOptions={[
        //   {
        //     SVGName: "star",
        //     text: "پشتیبانی",
        //     className: "w-fit",
        //     color: "blue",
        //   },
        //   {
        //     SVGName: "star",
        //     text: "مالی",
        //     className: "w-fit",
        //     color: "blue",
        //   },
        // ]}
        // activeFilter={activeFilter}
        // setActiveFilter={setActiveFilter}
        filter={false}
        sort={false}
        search={false}
      >
        <Table
          columns={[
            // { key: "uuid", label: "کد مدیر" },
            // {
            //   key: "category",
            //   label: "دسته مدیریتی",
            //   render: (value) =>
            //     value === "support" ? (
            //       <StatusColorful
            //         SVGName="star"
            //         text="پشتیبانی"
            //         className="w-fit"
            //         color="blue"
            //       />
            //     ) : value === "finance" ? (
            //       <StatusColorful
            //         SVGName="star"
            //         text="مالی"
            //         className="w-fit"
            //         color="blue"
            //       />
            //     ) : (
            //       ""
            //     ),
            // },
            { key: "name", label: "نام" },
            { key: "email", label: "ایمیل" },
            { key: "phoneNumber", label: "شماره تلفن" },
            // {
            //   key: "detail",
            //   label: "جزئیات",
            //   render: (value, row) => (
            //     <TableButton
            //       text="مشاهده"
            //       href=""
            //       onClick={() => {window.location.href = `/admins/admin-info`}}
            //       className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
            //     />
            //   ),
            // },
          ]}
          data={
            adminData
              ? adminData.map((item) => ({
                  name: item?.full_name || "-",
                  email: item?.email || "-",
                  phoneNumber: item?.phone_number || "-",
                }))
              : []
          }
        />
      </ContainerCustom>
    </>
  );
}
